import type { PluginObject } from 'vue'

import container from './di.container'

const DIPlugin: PluginObject<never> = {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$di = container
  },
}

export default DIPlugin
